import dayjs from 'dayjs';

export enum PlanType {
  // 用能计划
  ENERGY = 1,
  // 延时用能申请
  DELAY_ENERGY = 2,
}

export const PlanTypeDisplay = {
  [PlanType.ENERGY]: '用能计划',
  [PlanType.DELAY_ENERGY]: '延时用能申请',
};

export const PlanTypeColor = {
  [PlanType.ENERGY]: '#52E7FF',
  [PlanType.DELAY_ENERGY]: '#FF9247',
};

// 格式化时间显示
export const formatTimeRange = (baseTime: string, startTime?: string, endTime?: string) => {
  if (!startTime || !endTime) return;
  const base = dayjs(baseTime);
  const start = dayjs(startTime);
  const end = dayjs(endTime);

  // 判断开始时间是否为次日
  const isStartNextDay = start.isAfter(base, 'day');
  // 判断结束时间是否为次日
  const isEndNextDay = end.isAfter(base, 'day');

  const startFormatted = isStartNextDay ? `次日${start.format('HH:mm')}` : start.format('HH:mm');
  const endFormatted = isEndNextDay ? `次日${end.format('HH:mm')}` : end.format('HH:mm');

  return `${startFormatted}-${endFormatted}`;
};
